import React from 'react';

import { ListRow, Text } from '@betterment/samba-react';

import { StyledLinkRow, titleCss } from '../../../../../Shared/components-v2/styled-link-row/StyledLinkRow';
import { urlBuilder } from '../../../../../Shared/urlBuilder';
import { PerformanceAccountsQuery } from '../../../graphql/performanceAccounts.generated';

export const InvestingAccountRow: React.FC<{
  account: PerformanceAccountsQuery['performance']['accounts'][number];
}> = ({ account }) => {
  const { id, name } = account;

  return (
    <StyledLinkRow to={urlBuilder.appAccountPerformance.absolute({ accountId: id })} name={name}>
      <ListRow.LeadingContent>
        <Text color="text" css={titleCss}>
          {name}
        </Text>
      </ListRow.LeadingContent>
    </StyledLinkRow>
  );
};
